import { render, staticRenderFns } from "./releaseManage.vue?vue&type=template&id=96c93e7a&scoped=true"
import script from "./releaseManage.vue?vue&type=script&lang=js"
export * from "./releaseManage.vue?vue&type=script&lang=js"
import style0 from "./releaseManage.vue?vue&type=style&index=0&id=96c93e7a&lang=scss&scoped=true"
import style1 from "./releaseManage.vue?vue&type=style&index=1&id=96c93e7a&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c93e7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96c93e7a')) {
      api.createRecord('96c93e7a', component.options)
    } else {
      api.reload('96c93e7a', component.options)
    }
    module.hot.accept("./releaseManage.vue?vue&type=template&id=96c93e7a&scoped=true", function () {
      api.rerender('96c93e7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/applet/setting/companyapp/modules/releaseManage.vue"
export default component.exports